import type { ButtonProps, GridProps } from '@chakra-ui/react'
import { Box, Button, Grid } from '@chakra-ui/react'
import { Product } from 'BrokerTsLib/src/enums'
import type { ReactNode } from 'react'

import { useApp } from '@/hooks/useApp'
import { ArrowLeft } from '@/icons'

export type DashboardHeaderProps = {
  title?: string | ReactNode
} & Omit<GridProps, 'title'>

export const DashboardHeader = ({
  children,
  title,
  sx,
}: DashboardHeaderProps) => {
  const { product } = useApp()

  return (
    <Grid
      sx={{
        py: {base: 6, md: 20},
        pl: {base: 8, md: 0},
        placeItems: {base: 'start', md:'center'},
        position: 'relative',
        bg: 'dashboard-header-bg',
        ...sx,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          color: 'white',
          fontSize: {
            base: 'lg',
            md: '2xl',
            lg: '3xl',
          },
          fontWeight: 'medium',
          zIndex: 1,
        }}
      >
        {!title &&
          product == Product.VehicleLeasingInsurance &&
          'Pojištění motorových vozidel - leasing'}
        {!title &&
          product == Product.VehicleInsurance &&
          'Pojištění motorových vozidel'}
        {!title && product == Product.TravelInsurance && 'Cestovní pojištění'}
        {!title &&
          product == Product.PropertyInsurance &&
          'Pojištění majetku a odpovědnosti'}
        {title && title}
      </Box>

      {/* <IllustrationCar
        style={{
          position: 'absolute',
          top: '50%',
          right: 0,
          transform: 'translateY(-50%)',
        }}
      /> */}

      {children}
    </Grid>
  )
}

export const DashboardHeaderBackButton = ({
  onClick,
  children,
}: { onClick: () => void } & ButtonProps) => {
  return (
    <Button
      mx={'auto'}
      variant={'ghost'}
      colorScheme="primary"
      sx={{
        mx: 'auto',
        mt: { base: 4, sm: 6 },
        mb: { base: -2, sm: -4 },
      }}
      size={'sm'}
      onClick={onClick}
    >
      <ArrowLeft boxSize={4} />
      {children}
    </Button>
  )
}
